var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heading',[_vm._v(" "+_vm._s(_vm.$t("instructions.folder.title"))+" ")]),_c('instructionFolderTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }